<header id="header">
  <div class="SAS_Navbar">
    <div id="header-top-x" class="header-top">
      <div class="container">
        <div class="row">
          <!-- <div
            class="col-lg-4 col-sm-6 col-4 no-padding flex"
            style="justify-content: start"
          >
            <a
              routerLinkActive="active"
              class="login-btn"
              [routerLinkActiveOptions]="{ exact: true }"
              href="/login"
              >تسجيل الدخول لخدمة المنصة العلاجية
              <i class="fas fa-sign-in-alt pr-2"></i>
            </a>
          </div> -->
          <div
            class="col-lg-10 col-sm-8 col-8 header-top-right no-padding text-right"
          >
            <ul>
              <li>
                <a href="#" class="hdr-email" target="_blank">
                  <img
                    src="../../../assets/images/apple-app-store-logo-dark.png"
                    width="116px"
                    style="border-radius: 5px"
                  />
                </a>
              </li>
            </ul>

            <ul>
              <li>
                <a href="#" class="hdr-email" target="_blank">
                  <img
                    src="../../../assets/images/google-play.svg"
                    width="116px"
                  />
                </a>
              </li>
            </ul>

            <!-- <ul>
              <li>
                <a
                  href="https://wa.me/966112455503"
                  class="hdr-email"
                  target="_blank"
                >
                  <span dir="ltr" lang="en"> 966112455503 </span>
                  <img
                    src="assets/images/icons/whatsapp-icon.svg"
                    class="icon"
                    alt="whatsapp icon"
                  />
                </a>
              </li>
            </ul> -->

            <!-- <ul>
              <li>
                <a href="tel:966112455503" class="hdr-email" target="_blank">
                  <span dir="ltr" lang="en"> 966112455503 </span>
                  <img
                    src="assets/images/icons/phone-call.svg"
                    class="icon"
                    alt="phone icon"
                  />
                </a>
              </li>
            </ul> -->

            <!-- <ul>
              <li>
                <a
                  href="mailto:info@cpt-it.com"
                  class="hdr-email"
                  target="_blank"
                >
                  <span>info@cpt-it.com</span>
                  <img
                    src="assets/images/icons/mail-icon.svg"
                    class="icon"
                    alt="mail icon"
                  />
                </a>
              </li>
            </ul> -->

            <!-- <ul class="links">
              <li>
                <a href="https://story.snapchat.com" target="_blank">
                  <img
                    src="assets/images/icons/snapchat-icon.svg"
                    alt="snapchat icon"
                  />
                </a>
              </li>
              <li>
                <a href="https://twitter.com" target="_blank">
                  <img
                    src="assets/images/icons/twitter-icon.svg"
                    alt="twitter icon"
                  />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com" target="_blank">
                  <img
                    src="assets/images/icons/instagram-icon.svg"
                    alt="instagram icon"
                  />
                </a>
              </li>
            </ul> -->
          </div>
          <div
            class="col-lg-2 col-sm-4 col-4 no-padding flex"
            style="justify-content: end"
          >
            <a
              routerLinkActive="active"
              class="login-btn"
              [routerLinkActiveOptions]="{ exact: true }"
              href="/login"
            >
              <img src="assets/images/icons/avatar.svg" alt="user icon" />
              تسجيل الدخول
              <!-- <i class="fas fa-sign-in-alt pr-2"></i> -->
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="intro" class="Bar">
      <div class="container">
        <nav
          class="navbar navbar-expand-lg navbar-light ftco_navbar ftco-navbar-light"
          id="ftco-navbar"
        >
          <a class="navbar-brand" href="/">
            <!-- <img src="assets/images/logo.png" class="img-fluid" /> -->
            <img src="assets/images/new-logo.png" class="img-fluid" />
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i class="fas fa-bars"></i>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <!-- end-center class-navbar-nav -->
            <ul class="navbar-nav mr-auto">
              <li class="nav-item">
                <a
                  class="nav-link js-scroll"
                  data-value="defualt"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  href="/"
                >
                  الرئيسية</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link js-scroll"
                  data-value="AboutUs"
                  routerLinkActive="active"
                  href="/AboutUs"
                  >من نحن</a
                >
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownServices"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  خدماتنا
                  <!-- <i class="fas fa-sort-down"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow down icon"
                  />
                </a>
                <div
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdownServices"
                >
                  <li>
                    <a class="dropdown-item dropdown-toggle" href="#"
                      >للمرضى
                      <!-- <i class="fas fa-caret-left"></i> -->
                      <img
                        src="assets/images/icons/header-arrow-left.svg"
                        alt="arrow  icon"
                      />
                    </a>
                    <ul class="dropdown-menu removeEdge">
                      <li>
                        <a
                          class="dropdown-item"
                          routerLinkActive="active"
                          href="/MedicalCenter"
                          >المركز العلاجى</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          routerLinkActive="active"
                          href="/MedicalPlatform"
                          >المنصة العلاجية</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          routerLinkActive="active"
                          href="/Consultant"
                          >خدمة مستشارك في التخاطب</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          routerLinkActive="active"
                          href="/Awareness"
                          >زيادة الوعى بالاضطرابات والتعامل معها</a
                        >
                      </li>
                    </ul>
                  </li>

                  <li>
                    <a class="dropdown-item dropdown-toggle" href="#"
                      >للمختصين والمعنيين بالتخصص والمهتمين به

                      <!-- <i class="fas fa-caret-left"></i> -->
                      <img
                        src="assets/images/icons/header-arrow-left.svg"
                        alt="arrow  icon"
                      />
                    </a>
                    <ul class="dropdown-menu removeEdge">
                      <li>
                        <a
                          class="dropdown-item"
                          routerLinkActive="active"
                          href="/JoinUs"
                          >انضم لفريقنا</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          routerLinkActive="active"
                          href="/Research"
                          >الدراسات والأبحاث</a
                        >
                      </li>
                      <!-- <li>
                        <a
                          class="dropdown-item"
                          routerLinkActive="active"
                          href="/Statistics"
                          >الاحصائيات والمعلومات</a
                        >
                      </li> -->
                    </ul>
                  </li>
                </div>
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownPlatform"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  المنصة العلاجية
                  <!-- <i class="fas fa-sort-down"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow down icon"
                  />
                </a>
                <div
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdownPlatform"
                >
                  <a
                    class="dropdown-item"
                    routerLinkActive="active"
                    href="/MedicalPlatform"
                    >التعريف بالمنصة</a
                  >
                  <a
                    class="dropdown-item"
                    routerLinkActive="active"
                    href="/auth/basic-data/Platform"
                    >التشخيص</a
                  >
                  <a
                    class="dropdown-item"
                    routerLinkActive="active"
                    href="/Sas/TreatmentPlatform"
                    >العلاج</a
                  >
                </div>
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownCenter"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  المركز العلاجي
                  <!-- <i class="fas fa-sort-down"></i> -->
                  <img
                    src="assets/images/icons/header-arrow-down.svg"
                    alt="arrow down icon"
                  />
                </a>
                <div
                  class="dropdown-menu"
                  aria-labelledby="navbarDropdownCenter"
                >
                  <a
                    class="dropdown-item"
                    routerLinkActive="active"
                    href="/MedicalCenter"
                    >عن المركز العلاجى</a
                  >
                  <a class="dropdown-item" href="/Default#Specialties"
                    >التخصصات</a
                  >
                </div>
              </li>

              <li class="nav-item">
                <a
                  class="nav-link"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  href="/Consultant"
                  >خدمة مستشارك في التخاطب</a
                >
              </li>

              <li class="nav-item">
                <a class="nav-link" routerLinkActive="active" href="/ContactUs"
                  >تواصل معنا</a
                >
              </li>
            </ul>
            <!-- end-right class-navbar-nav -->
          </div>
        </nav>
      </div>
    </div>
  </div>
</header>
